import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { computed, defineComponent, onMounted, ref, toRefs, watch } from "@vue/composition-api";
import RadioSection from "@Shared/components/sections/radio-section.vue";
import EmailEditor from "@Shared/components/inputs/email-editor.vue";
import AutomationEmailReadOnly from "../components/argument-types/email-readonly.vue";
import { useI18n } from "vue-i18n-composable";
import { flattenDepth, uniqueId } from "lodash";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { useApplicationListStoreState, useApplicationListStoreActions } from "@Broker/@Modules/clients/applications/application/applications-list/store/applications-list-helpers";
const tags = ["{{FIRST_NAME}} ", "{{LAST_NAME}} "];
export default defineComponent({
  components: {
    RadioSection,
    EmailEditor,
    AutomationEmailReadOnly,
    MaterialInput
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: () => -1
    },
    value: {
      type: Object,
      default: () => ({
        value: {
          application: false,
          option: "mainApplicant",
          bankStatements: false,
          userMessage: `<br><br>`,
          applicationType: ""
        }
      })
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    valueOnly: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, {
    emit
  }) {
    const {
      tc,
      t
    } = useI18n();
    const {
      value,
      readOnly,
      trigger
    } = toRefs(props);
    const {
      flows
    } = useApplicationListStoreState(["flows"]);
    const {
      LOAD_FLOWS
    } = useApplicationListStoreActions(["LOAD_FLOWS"]);
    onMounted(() => {
      LOAD_FLOWS();
    });
    const isCreate = computed(() => {
      var _trigger$value;
      return ((_trigger$value = trigger.value) == null ? void 0 : _trigger$value.key) === "client-profile-created";
    });
    const flowsColumns = computed(() => {
      var _flows$value, _flows$value$sections;
      const options = (_flows$value = flows.value) == null ? void 0 : (_flows$value$sections = _flows$value.sections) == null ? void 0 : _mapInstanceProperty(_flows$value$sections).call(_flows$value$sections, sections => {
        var _context;
        return _mapInstanceProperty(_context = sections.columns).call(_context, column => {
          var _context2;
          return _mapInstanceProperty(_context2 = column.options).call(_context2, option => _objectSpread(_objectSpread({}, option), {}, {
            label: t(`application-flow.flows.${option.value}`)
          }));
        });
      });
      return flattenDepth(options, 2);
    });
    const {
      application,
      option,
      bankStatements,
      userMessage: userMessageProp,
      applicationType
    } = value == null ? void 0 : value.value;
    const includeSendApplication = ref(application);
    const userMessage = ref(userMessageProp);
    const emailEditor = ref();
    const applicationFlow = ref(applicationType != null ? applicationType : "purchase-preapproval");
    const includeBankStatements = ref(bankStatements);
    const selectedOption = ref(option != null ? option : "mainApplicant");
    const requestOptions = computed(() => {
      if (includeBankStatements.value) {
        if (includeSendApplication.value) {
          return 2;
        }
        return 1;
      }
      return 0;
    });
    const coApplicantsSendOptions = computed(() => [{
      label: tc("automations.requestPackage.sendMainApplicant", requestOptions.value),
      value: "mainApplicant"
    }, {
      label: tc("automations.requestPackage.sendAllCoApplicants", requestOptions.value),
      value: "coapplicants"
    }]);
    const colOptions = computed(() => readOnly.value ? {
      flows: {
        cols: "12",
        lg: "6"
      },
      options: {
        cols: "12",
        xl: "6"
      }
    } : {
      flows: {
        cols: "12",
        lg: "4",
        md: "5",
        sm: "6",
        xxl: "3"
      },
      options: {
        cols: "12",
        lg: "6",
        xxl: "3"
      }
    });
    const radioId = uniqueId(`request-options`);
    const radioFlowId = uniqueId(`request-flow-options`);
    const handleOptionChange = value => {
      selectedOption.value = value;
    };
    const handleApplicationChange = () => {
      includeSendApplication.value = !includeSendApplication.value;
    };
    const handleApplicationTypeChange = flow => {
      if (flow == "") {
        return;
      }
      applicationFlow.value = flow;
    };
    const handleBankStatementsChange = () => {
      includeBankStatements.value = !includeBankStatements.value;
    };
    const handleEditorChange = ({
      content
    }) => {
      userMessage.value = content;
    };
    const handleTag = tag => {
      emailEditor.value.insertText(tag);
    };
    watch(value, newValue => {
      if (newValue) {
        const {
          application,
          option,
          bankStatements,
          userMessage: userMessageProp,
          applicationType
        } = newValue;
        includeSendApplication.value = application;
        userMessage.value = userMessageProp;
        applicationFlow.value = applicationType;
        includeBankStatements.value = bankStatements;
        selectedOption.value = option;
      }
    });
    watch([includeSendApplication, includeBankStatements, selectedOption, userMessage, applicationFlow], ([applicationValue, bankStatementsValue, optionValue, userMessageValue, applicationFlowValue]) => {
      if ((applicationValue || bankStatementsValue) && applicationFlowValue != "") {
        emit("input", {
          application: applicationValue,
          bankStatements: bankStatementsValue,
          option: optionValue,
          userMessage: userMessageValue,
          applicationType: applicationFlowValue
        });
      } else {
        emit("input", null);
      }
    });
    return {
      includeSendApplication,
      includeBankStatements,
      selectedOption,
      coApplicantsSendOptions,
      handleOptionChange,
      handleApplicationChange,
      handleBankStatementsChange,
      handleEditorChange,
      handleApplicationTypeChange,
      radioId,
      tags,
      emailEditor,
      userMessage,
      handleTag,
      requestOptions,
      flowsColumns,
      flows,
      applicationFlow,
      radioFlowId,
      colOptions,
      isCreate
    };
  }
});